import { FC } from 'react';
import { Box, FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import StyledLabel from 'modules/map/components/daily-dish/components/utils/StyledLabel';
import { FIELD_WIDTHS } from 'modules/map/components/daily-dish/constants';

interface SelectFieldOption {
  value: string | number;
  label: string;
}

interface SelectFieldProps {
  label: string;
  value: string | number;
  options: readonly SelectFieldOption[];
  onChange: (value: string | number) => void;
  disabled?: boolean;
  width?: string;
}

/**
 * Reusable select field component
 */
export const SelectField: FC<SelectFieldProps> = ({
  label,
  value,
  options,
  onChange,
  disabled = false,
  width = FIELD_WIDTHS.HALF,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <Box sx={{ width }}>
      {label && <StyledLabel label={label} />}
      <FormControl fullWidth>
        <Select value={String(value)} onChange={handleChange} disabled={disabled}>
          {options.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
